import * as React from "react";
const SvgVolumeMax = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3336 7.50019C13.8567 8.19658 14.1667 9.06219 14.1667 10.0002C14.1667 10.9382 13.8567 11.8038 13.3336 12.5002M15 4.40993C16.5344 5.78323 17.5 7.77894 17.5 10.0002C17.5 12.2214 16.5344 14.2172 15 15.5905M3.83333 7.50019H4.58433C5.04344 7.50019 5.27299 7.50019 5.48571 7.44296C5.67419 7.39226 5.85229 7.30883 6.01191 7.19651C6.19205 7.06973 6.33901 6.89338 6.63292 6.54068L8.82119 3.91477C9.18426 3.47909 9.36579 3.26124 9.52436 3.23857C9.66168 3.21894 9.79977 3.26894 9.89269 3.37193C10 3.49086 10 3.77443 10 4.34156V15.6588C10 16.226 10 16.5095 9.89269 16.6285C9.79977 16.7315 9.66168 16.7814 9.52436 16.7618C9.36579 16.7391 9.18424 16.5213 8.82119 16.0856L6.63292 13.4597C6.33901 13.107 6.19205 12.9307 6.01191 12.8039C5.85229 12.6916 5.67419 12.6081 5.48571 12.5574C5.27299 12.5002 5.04344 12.5002 4.58433 12.5002H3.83333C3.36662 12.5002 3.13327 12.5002 2.95501 12.4094C2.79821 12.3295 2.67072 12.202 2.59083 12.0452C2.5 11.8669 2.5 11.6336 2.5 11.1669V8.83353C2.5 8.36682 2.5 8.13346 2.59083 7.9552C2.67072 7.7984 2.79821 7.67092 2.95501 7.59102C3.13327 7.50019 3.36662 7.50019 3.83333 7.50019Z",
      stroke: "currentColor",
      strokeWidth: 1.66667,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgVolumeMax;
